import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"

import logo from "../components/images/logo.svg"
import back from "../components/images/back.svg"


const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  let header

  if (location.pathname === rootPath) {
    header = (
      <div>
        <div>
          <h1
            style={{
              ...scale(1),
              marginBottom: rhythm(1),
              marginTop: 0,
            }}
          >
            <div className="menu-header">
              <Link
                style={{
                  boxShadow: `none`,
                  color: `inherit`,
                }}
                to={rootPath}
              >
                <img className="header-logo" src={logo} alt="restaurant icon" />
              </Link>
            </div>
          </h1>
        </div >
      </div>
    )
  } else {
    header = (
      <div>
        <div>
          <h1
            style={{
              ...scale(1),
              marginBottom: rhythm(0),
              marginTop: 0,
            }}
          >
            <div className="menu-header">
              <Link
                style={{
                  boxShadow: `none`,
                  color: `inherit`,
                }}
                to={rootPath}
              >
                <img className="header-logo" src={logo} alt="restaurant icon" />
              </Link>
            </div>
          </h1>
        </div >
        <Link
          style={{
            boxShadow: `none`,
            color: `inherit`,
          }}
          to={rootPath}
        >
          <div className="back-to-home"><img src={back} alt="back" /><span class="back-text">Back</span></div>
        </Link>

      </div>
    )
  }

  // if (location.pathname === rootPath) {
  //   header = (
  //     <h1
  //       style={{
  //         ...scale(1),
  //         marginBottom: rhythm(1),
  //         marginTop: 0,
  //       }}
  //     >
  //       <div className="menu-header">
  //         <img src={restaurant} alt="restaurant icon" />
  //       </div>
  //     </h1>
  //   )
  // } else {
  //   header = (
  //     <h3
  //       style={{
  //         fontFamily: `Montserrat, sans-serif`,
  //         marginTop: 0,
  //       }}
  //     >
  //       <Link
  //         style={{
  //           boxShadow: `none`,
  //           color: `inherit`,
  //         }}
  //         to={`/`}
  //       >
  //         {title}
  //       </Link>
  //     </h3>
  //   )
  // }
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(24),
        padding: `0rem 0`,
      }}
    >
      <header>{header}</header>
      <main>{children}</main>
      <footer>
        © {new Date().getFullYear()}, Powered by
        {` `}
        <a href="https://umidigital.co.uk">Umi Digital</a>
      </footer>
    </div>
  )
}

export default Layout
